import React, { createContext, useReducer } from 'react';

import { reducer as childReducer, initialState as childInitialState } from './child';
import { reducer as measurementsReducer, initialState as measurementsInitialState } from './measurements';
import { reducer as growthChartReducer, initialState as growthChartInitialState } from './growthChart';
import { reducer as optionsReducer, initialState as optionsInitialState } from './options';

const initialState = {
    child: childInitialState,
    measurements: measurementsInitialState,
    growthChart: growthChartInitialState,
    options: optionsInitialState,
};

const reducer = (state, action) => {
    const newState = {
        child: childReducer(state.child, action),
        measurements: measurementsReducer(state.measurements, action),
        growthChart: growthChartReducer(state.growthChart, action),
        options: optionsReducer(state.options, action),
    };
    return newState;
};

export const GlobalContext = createContext({
    state: initialState,
    dispatch: null,
});

export const GlobalProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return <GlobalContext.Provider value={{ state, dispatch }}>{children}</GlobalContext.Provider>;
};
